import { render, staticRenderFns } from "./text-input.vue?vue&type=template&id=3cb2ec43"
import script from "./text-input.ts?vue&type=script&lang=js&external"
export * from "./text-input.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports